//imports
import React from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';

//controls
import { Tabs, TabContainer, Container } from "@gpstrackit/gtc-react-controls";

//styles
// import "./main.scss";

//views
import VehiclesTab from "./components/vehiclesTab";
import ServicesTab from "./components/servicesTab";
import DriversTab from "./components/driversTab";
import EmissionCheckTab from "./components/emissionCheckTab";

import { HasPermission } from "../../../../core/security";

const MaintenanceMainView = () => {
    const { messages } = useIntl();
    const { id } = useParams();
    const user = useSelector(state => state.securityRedux.user);

    const tabsItems = [
        {
            label: messages["mainView_vehicles"],
            index: 0,
            component: <VehiclesTab />,
        },
        {
            label: messages["mainView_services"],
            index: 1,
            component: <ServicesTab />,
        },
        {
            label: messages["mainView_drivers"],
            index: 2,
            component: <DriversTab />,
        }
    ];

    // check permission for CARB
    if (HasPermission(user, ["carb"], [317])) {
        tabsItems.push({
            label: messages["mainView_emission_check"],
            index: 3,
            component: <EmissionCheckTab />,
        })
    }

    return (
        <Container maxWidth={false} className="container-view">
            <Tabs tab={id?.length > 0 ? parseInt(id) : 0}>
                {tabsItems.map((item) => {
                    const { label, component, index } = item
                    return (
                        <TabContainer key={index} label={label} index={index}>
                            {component}
                        </TabContainer>
                    );
                })}
            </Tabs>
        </Container>
    );
};

export default MaintenanceMainView;
